import { useEffect } from "react";
import { useSelector } from "react-redux";
import { datadogRum } from "@datadog/browser-rum";

const useDatadogUserTracking = () => {
  const user = useSelector((state: any) => state?.user?.account);

  useEffect(() => {
    if (!datadogRum) {
      console.warn("Datadog RUM not initialized");
      return;
    }
    try {
      if (user?.PersonEmail) {
        datadogRum.setUser({
          id: user?.PersonEmail,
          email: user?.PersonEmail
        });
      } else {
        datadogRum.clearUser();
      }
    } catch (error) {
      console.warn("Datadog user session error:", error);
    }
  }, [user]);
};

const DatadogUserWrapper = () => {
  useDatadogUserTracking();
  return null;
};

export default DatadogUserWrapper;
